import { TableBaseCols } from '@ge/feat-reporting/components/widgets/table-widget/table-base-cols';

// All available columns and groups for completed work
export const InternalUptowerRepairDamagesColumns = {
  GROUP_SELECTED: TableBaseCols.GROUP_SELECTED,
  SELECTED: TableBaseCols.SELECTED,

  GROUP_COLUMNS: 'Columns',
  ASSET: 'Asset',
  MODEL: 'Model',
  COMPONENT: 'Component',
  LOCATION: 'Location',
  DAMAGE: 'Damage',
  PAC: 'pacNumber',
  CATEGORY: 'Category',
  P50: 'p50',
  P90: 'p90',
  SERIAL_NUMBER: 'Serial Number',
  MANUFACTURER: 'Manufacturer',
  PART: 'Part',
};

// Completed work table configuration
export const internalUptowerRepairDamagesColumnsDefs = {
  [InternalUptowerRepairDamagesColumns.GROUP_COLUMNS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'external_damages.columns.group_columns',
        a11yDefault: 'Columns',
      },
    ],
    cols: {
      [InternalUptowerRepairDamagesColumns.ASSET]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.asset_name',
            a11yDefault: 'Asset',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.MODEL]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.model',
            a11yDefault: 'Model',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.COMPONENT]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.component',
            a11yDefault: 'Component',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.LOCATION]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.location',
            a11yDefault: 'Location',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.DAMAGE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.damage',
            a11yDefault: 'Damage',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.PAC]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.pac',
            a11yDefault: 'PAC #',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.PART]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.part',
            a11yDefault: 'Part',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.CATEGORY]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.category',
            a11yDefault: 'Category',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.MANUFACTURER]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.manufacturer',
            a11yDefault: 'Manufacturer',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.P50]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.rul_50',
            a11yDefault: 'RUL P50',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.P90]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.rul_90',
            a11yDefault: 'RUL P90',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalUptowerRepairDamagesColumns.SERIAL_NUMBER]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.serial_number',
            a11yDefault: 'Serial Number',
          },
        ],
        cell: {
          align: 'left',
        },
      },
    },
  },
};

export const InternalUptowerRepairDamagesColumnsDefaultCols = [
  {
    id: InternalUptowerRepairDamagesColumns.GROUP_COLUMNS,
    ignoreTemplateConfig: true,
    cols: [
      {
        id: InternalUptowerRepairDamagesColumns.ASSET,
        visible: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.MODEL,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.COMPONENT,
        visible: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.LOCATION,
        visible: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.DAMAGE,
        visible: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.PAC,
        visible: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.PART,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.CATEGORY,
        visible: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.MANUFACTURER,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.P50,
        visible: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.P90,
        visible: true,
      },
      {
        id: InternalUptowerRepairDamagesColumns.SERIAL_NUMBER,
        visible: false,
        ignoreTemplateConfig: true,
      },
    ],
  },
];

export const PerformanceStateKeys = {
  CONFIG_STATE: 'configState',
};
